// extracted by mini-css-extract-plugin
export default {"inviteControl":"_1lGQbawM"};